module.exports = __webpack_public_path__ + "static/media/localizacao.1799e947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/localizacao.jpg
// module id = 88
// module chunks = 0